(function autoAddSetupFee() {
  function init() {
    const dataScript = document.querySelector('script[data-section-id="WC__auto-add-setup-fee"]');
    console.log("🏁 autoAddSetupFee init, dataScript:", dataScript);
    if (dataScript === null) return;
    const settings = JSON.parse(dataScript.innerHTML);
    console.log("⚙️ setup fee settings:", settings);

    if (!settings.enable_setup_fee || !settings.setup_fee_variant_id) return;

    const SETUP_FEE_VARIANT_ID = settings.setup_fee_variant_id;

    function trackClarity(action, status, location) {
      if (typeof window.clarity === 'function') {
        window.clarity("set", "setup_fee_action", action);
        window.clarity("set", "setup_fee_status", status);
        window.clarity("set", "setup_fee_location", location);
        window.clarity("event", "setup_fee_" + action + "_" + status);
      }
    }

    function getCartLocation() {
      return window.location.pathname.includes('/cart') ? 'cart_page' : 'cart_drawer';
    }

    let setupFeePromise = Promise.resolve();

    subscribe("cart-update", ({ source } = {}) => {
      console.log("🔔 Cart updated! source:", source);
      if (source === 'ymq') {
        console.log("⏭️ Skipping manageSetupFee for source:", source);
        return;
      }
      setupFeePromise = manageSetupFee();
    });

    async function manageSetupFee() {
      try {
        console.log("🔍 manageSetupFee: fetching cart...");
        const response = await fetch('/cart.js');
        console.log("🔍 cart.js response status:", response.status, response.ok);
        const cart = await response.json();
        console.log("🔍 cart.js parsed, item count:", cart.items?.length);

        const setupFeeItems = cart.items.filter(item => item.variant_id === SETUP_FEE_VARIANT_ID);
        const setupFeeCount = setupFeeItems.length;
        const regularItemsCount = cart.items.filter(item => item.variant_id !== SETUP_FEE_VARIANT_ID).length;

        console.log(`🛒 Regular items: ${regularItemsCount}, Setup fees: ${setupFeeCount}, SETUP_FEE_VARIANT_ID: ${SETUP_FEE_VARIANT_ID}`);
        console.log("🛒 Cart items:", cart.items.map(i => ({ id: i.variant_id, title: i.title, qty: i.quantity })));

        if (setupFeeCount > 1) {
          console.log(`⚠️ Found ${setupFeeCount} setup fees, removing extras...`);
          await removeExtraSetupFees(cart, setupFeeItems);
          return;
        }

        if (setupFeeCount === 1 && setupFeeItems[0].quantity > 1) {
          console.log(`⚠️ Setup fee quantity is ${setupFeeItems[0].quantity}, fixing to 1...`);
          await fixSetupFeeQuantity(cart, setupFeeItems[0]);
          return;
        }

        if (regularItemsCount > 0 && setupFeeCount === 0) {
          await addSetupFee();
        } else if (regularItemsCount === 0 && setupFeeCount > 0) {
          await removeSetupFee(cart);
        }
      } catch (error) {
        console.error("❌ Error managing setup fee:", error, error?.message, error?.stack);
      }
    }

    async function addSetupFee() {
      try {
        console.log("➕ addSetupFee: attempting to add variant", SETUP_FEE_VARIANT_ID);
        const formData = new FormData();
        formData.append('id', SETUP_FEE_VARIANT_ID);
        formData.append('quantity', 1);

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        console.log("➕ addSetupFee: response status", response.status);
        if (response.ok) {
          const data = await response.json();
          console.log("✅ Setup fee added");
          trackClarity("added", "success", getCartLocation());

          const isCartPage = window.location.pathname.includes('/cart');
          if (isCartPage) {
            console.log("🔄 Reloading cart page...");
            window.location.reload();
          } else {
            publish('cart-update', { source: 'setup-fee-manager', cartData: data });
          }
        } else {
          const errText = await response.text();
          console.error("❌ addSetupFee failed:", response.status, errText);
          trackClarity("added", "failed", getCartLocation());
        }
      } catch (error) {
        console.error("❌ Error adding setup fee:", error);
        trackClarity("added", "error", getCartLocation());
      }
    }

    async function removeSetupFee(cart) {
      try {
        const setupFeeLineIndex = cart.items.findIndex(item => item.variant_id === SETUP_FEE_VARIANT_ID);
        if (setupFeeLineIndex === -1) return;

        const line = setupFeeLineIndex + 1;
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line, quantity: 0 })
        });

        if (response.ok) {
          const data = await response.json();
          console.log("✅ Setup fee removed");
          trackClarity("removed", "success", getCartLocation());

          const isCartPage = window.location.pathname.includes('/cart');
          if (isCartPage) {
            console.log("🔄 Reloading cart page...");
            window.location.reload();
          } else {
            publish('cart-update', { source: 'setup-fee-manager', cartData: data });
          }
        } else {
          trackClarity("removed", "failed", getCartLocation());
        }
      } catch (error) {
        console.error("❌ Error removing setup fee:", error);
        trackClarity("removed", "error", getCartLocation());
      }
    }

    async function removeExtraSetupFees(cart, setupFeeItems) {
      try {
        for (let i = setupFeeItems.length - 1; i >= 1; i--) {
          const line = cart.items.indexOf(setupFeeItems[i]) + 1;
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line, quantity: 0 })
          });
          console.log(`🗑️ Removed duplicate setup fee #${i + 1}`);
        }

        trackClarity("removed_extras", "success", getCartLocation());

        const isCartPage = window.location.pathname.includes('/cart');
        if (isCartPage) {
          window.location.reload();
        } else {
          const response = await fetch('/cart.js');
          const updatedCart = await response.json();
          publish('cart-update', { source: 'setup-fee-manager', cartData: updatedCart });
        }
      } catch (error) {
        console.error("❌ Error removing extra setup fees:", error);
        trackClarity("removed_extras", "error", getCartLocation());
      }
    }

    async function fixSetupFeeQuantity(cart, setupFeeItem) {
      try {
        const line = cart.items.indexOf(setupFeeItem) + 1;
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line, quantity: 1 })
        });

        if (response.ok) {
          const data = await response.json();
          console.log("✅ Setup fee quantity fixed to 1");
          trackClarity("fixed_qty", "success", getCartLocation());

          const isCartPage = window.location.pathname.includes('/cart');
          if (isCartPage) {
            window.location.reload();
          } else {
            publish('cart-update', { source: 'setup-fee-manager', cartData: data });
          }
        } else {
          trackClarity("fixed_qty", "failed", getCartLocation());
        }
      } catch (error) {
        console.error("❌ Error fixing setup fee quantity:", error);
        trackClarity("fixed_qty", "error", getCartLocation());
      }
    }

    console.log("✅ autoAddSetupFee fully initialized, variant ID:", SETUP_FEE_VARIANT_ID);
    manageSetupFee();

    window.afterValidateBundleVariant = function() {
      console.log('[YMQ] afterValidateBundleVariant fired');
      manageSetupFee().then(() => {
        console.log('[YMQ] manageSetupFee done, publishing cart-update ymq');
        publish('cart-update', { source: 'ymq' });
      });
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
